<template>
  <v-container class="main-calendar-body">
    <!-- <v-btn @click="move(-7)">back one week</v-btn>
    <v-btn @click="move(-1)">back one day</v-btn>
    <v-btn @click="move(1)">next one day</v-btn>
    <v-btn @click="move(7)">next one week</v-btn> -->
    <v-sheet :height="eventSettings.isOnlineSessionAvailable ? '125' : '64'">
      <div class="mb-sm">
        <h1 class="text-center calendar-title text-capitalize">
          {{
            eventStartDate
              ? $dayjs(eventStartDate).format("MMMM YYYY")
              : $t("calendar.loading")
          }}
        </h1>

        <v-row
          v-if="eventSettings.isOnlineSessionAvailable"
          class="pt-4"
          :class="screenSize == 'xs' ? '' : 'mx-13'"
          ><v-col>
            <v-btn
              block
              x-large
              @click="showDate(null)"
              class="text-center calendar-on-demand no-uppercase"
              style="color: white"
              >{{ $t("calendar.onDemandLink") }}
            </v-btn>
          </v-col></v-row
        >
      </div>
    </v-sheet>
    <v-sheet
      class="d-flex flex-row vuetify-calendar"
      v-if="calendarEventsDetail && eventStartDate">
      <v-btn
        icon
        @click="move(-1)"
        class="calendar-back-button"
        variant="plain">
        <v-icon size="50">mdi-chevron-left</v-icon></v-btn
      >
      <v-calendar
        class="flex-grow-1"
        :key="this.$store.getters['getCalendarKey']"
        ref="calendar"
        :locale="getLanguage"
        :start="eventStartDate"
        color="lightprimary"
        :events="calendarEventsDetail"
        :event-text-color="getEventTextColor"
        first-interval="7"
        interval-count="15"
        interval-height="80"
        :interval-format="getIntervalDisplay"
        event-overlap-mode="column"
        :type="type"
        :weekdays="weekday"
        @click:event="showEvent"
        @click:more="showDate"
        @click:date="showDate">
        <template v-slot:event="{ event }">
          <div
            class="event-slot"
            style="overflow: hidden; text-overflow: ellipsis; max-height: 100%"
            :class="{
              'single-line': event.duration <= 30,
              small: event.duration <= 20,
            }">
            <span class="event-time">
              {{ $dayjs(event.start).format("H:mm") }} -
              {{ $dayjs(event.end).format("H:mm") }}
            </span>
            <br v-if="event.duration > 30" />
            <span
              class="event-detail"
              :class="{
                block: event.duration > 30,
                'smaller-text': event.duration > 30 && event.duration < 60,
              }">
              {{ event.name }}
            </span>
          </div>
        </template>
      </v-calendar>
      <div class="calendar-right-box d-flex justify-center">
        <v-btn icon @click="move(1)" variant="plain" class="align-self-center">
          <v-icon size="50">mdi-chevron-right</v-icon></v-btn
        >
      </div>
    </v-sheet>
    <day-schedule-dialog
      :isDialogOpen="isDayScheduleDialogOpen"
      @closed="isDayScheduleDialogOpen = !$emit"></day-schedule-dialog>
  </v-container>
</template>
<script>
import DayScheduleDialog from "../components/DayScheduleDialog";
export default {
  name: "Calendar",
  data: () => ({
    focus: "",
    type: "week",
    events: [],
    selectedEventTrackIds: "",
    isDayScheduleDialogOpen: false,
  }),
  computed: {
    screenSize() {
      return this.$vuetify.breakpoint.name;
    },
    eventSettings() {
      return this.$store.getters["getSettings"];
    },
    calendarEventsDetail() {
      return this.$store.getters["getCalendarEventsDetail"];
    },
    weekday() {
      var startingDay = this.$dayjs(this.eventStartDate).day();
      var dayArray = [];
      var maximumDay = this.eventSettings.eventDayDisplayedCount;
      if (this.screenSize == "xs") maximumDay = 1;
      if (maximumDay > 7) maximumDay = 7;

      for (let i = 0; i < maximumDay; i++) {
        dayArray.push((i + startingDay) % 7);
      }

      return dayArray;
    },
    eventStartDate: {
      get() {
        return this.$store.getters["getCalendarStartingDate"];
      },
      set(day) {
        return this.$store.dispatch("changeCalendarStartingDate", day);
      },
    },
    daySelected: {
      get() {
        return this.$store.getters["getDaySelected"];
      },
      set(day) {
        return this.$store.dispatch("changeDaySelected", day);
      },
    },
    timeSlotSelected: {
      get() {
        return this.$store.getters["getTimeSlotSelected"];
      },
      set(timeslot) {
        return this.$store.dispatch("changeTimeSlotSelected", timeslot);
      },
    },
    sessionTypeSelected: {
      get() {
        return this.$store.getters["getSessionTypeSelected"];
      },
      set(timeslot) {
        return this.$store.dispatch("changeSessionTypeSelected", timeslot);
      },
    },
    getLanguage: {
      get() {
        return this.$store.getters["getLanguage"];
      },
    },
  },
  methods: {
    async viewDay(isSlotSelected) {
      console.log(this.$vuetify.breakpoint);
      if (!isSlotSelected)
        await this.$store.dispatch("fetchDay", { day: this.daySelected, trackIds: this.selectedEventTrackIds, allDay: true });
      else await this.$store.dispatch("fetchDay", { day: this.daySelected, trackIds: this.selectedEventTrackIds, allDay: false });

      document.documentElement.classList.add("remove-sidebar");

      this.isDayScheduleDialogOpen = true;
    },
    setToday() {
      this.focus = "";
    },
    move(day) {
      this.eventStartDate = this.$dayjs(this.eventStartDate)
        .add(day, "day")
        .format("YYYY-MM-DDTHH:mm:ss");
    },
    getIntervalDisplay(date) {
      return this.$dayjs(date.date + " " + date.time).format("H:mm");
    },
    getEventTextColor(event) {
      return event.textcolor;
    },
    showDate(dateClicked) {
      if (dateClicked != null) this.daySelected = dateClicked.date;
      else this.daySelected = null;
      this.timeSlotSelected = null;
      this.selectedEventTrackIds = "";
      this.viewDay(false);
    },
    showEvent({ nativeEvent, event }) {
      if (event.url !== "" && event.url !== undefined && event.url !== null)
        window.open(event.url);
      else {
        this.daySelected = event.start;
        this.timeSlotSelected = [event.start, event.end, event.name];
        this.selectedEventTrackIds = event.trackIds;
        if (!event.end) {
          if (event.name.includes("Video")) {
            this.sessionTypeSelected = "video";
          } else if (event.name.includes("Poster")) {
            this.sessionTypeSelected = "poster";
          }
        }
        this.viewDay(true);
      }
      nativeEvent.stopPropagation();
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
  components: {
    "day-schedule-dialog": DayScheduleDialog,
  },
};
</script>
